module.exports = __webpack_public_path__ + "img/2_ua.b0dd4b7d.webp";